import React, { Component } from 'react';
import countapi from 'countapi-js';

class VisitLingue extends Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  componentDidMount() {
    countapi.visits('languages').then((result) => {
      console.log(result)
      this.setState({ visiteLingue: result.value });
    });
  }

  render() {

    return (
      <span style={{fontSize: '18px', marginBottom: '-20.5px'}} title="Numero delle visite sulla pagina 'Lingue'">(👁 {this.state.visiteLingue})</span>
    );

  }
}

export default VisitLingue;